<ng-container *ngIf="giftRedeemInfo && giftRedeemInfo.giftDetails else errorHandling">
  <div class="container-narrow my-5">
    <div class="text-center mb-5">
      <h4 class="text-primary fw-bold"
          [translate]="'GIFTS.REDEEM.HEADER'"></h4>
      <p [innerHTML]="'GIFTS.REDEEM.DESCRIPTION' | translate"></p>
      <div class="my-5">
        <app-gift-card [gift]="giftRedeemInfo.giftDetails">
          <div class="d-flex flex-column justify-content-center w-100">
            <div class="text-end mt-auto mb-auto mb-3 mh-120">
              <p class="h5 text-white"
                 [translate]="'GIFTS.REDEEM.YOUR-CODE'"></p>
              <div class="d-flex">
                <input #giftCodeInput
                       type="text"
                       class="h1 fw-bold ms-1"
                       [(ngModel)]="giftRedeemInfo.giftCode.assignedGiftCode"
                       (click)="giftCodeInput.select()"
                       readonly>
                <button class="copy-btn"
                        data-toggle="tooltip"
                        title="{{ 'GIFTS.REDEEM.COPY' | translate }}"
                        (click)="copyGiftCode()">
                  <i-feather name="copy"></i-feather>
                </button>
              </div>
              <p *ngIf="copied"
                 class="h6 text-white text-end"
                 [translate]="'GIFTS.REDEEM.COPIED'"></p>
            </div>
            <div class="text-end mt-3 mb-3">
              <a [attr.href]="giftRedeemInfo.giftCode.giftRedeemWebsiteUrl"
                 class="btn btn-primary shadow-sm"
                 target="_blank"
                 rel="nofollow noopener noreferrer"
                 [translate]="'GIFTS.REDEEM.BUTTON-PARTNERS-SITE'"></a>
            </div>
          </div>
        </app-gift-card>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #errorHandling>
  <div class="container-narrow my-5">
    <div class="row mt-5">
      <div class="col-12">
        <ng-container *ngIf="outOfCodes else standardError">
          <h1 class="h3 fw-bolder"
              [translate]="'GIFTS.REDEEM.ERROR-OUT-OF-CODES.TITLE'"></h1>
          <p class="pre-wrap"
             [translate]="'GIFTS.REDEEM.ERROR-OUT-OF-CODES.DESCRIPTION'"></p>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #standardError>
  <h1 class="h3 fw-bolder"
      [translate]="'GIFTS.REDEEM.ERROR-GENERAL.TITLE'"></h1>
  <p class="pre-wrap"
     [translate]="'GIFTS.REDEEM.ERROR-GENERAL.DESCRIPTION'"></p>
</ng-template>
